<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    @if (isEditing()) {
    Edit Customer ({{ title || 'N/A' }})
    } @else {
    Add Customer
    }
  </div>
  <button mat-icon-button class="close-btn" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <form (ngSubmit)="saveCustomerData()" class="form-grid">
    <!-- First Row -->
    <div class="form-grid-row cols-2">
      <mat-form-field appearance="outline">
        <mat-label>Customer Name</mat-label>
        <input matInput [(ngModel)]="customerName" #nameControl="ngModel" name="customerName"
          placeholder="Enter Customer Name" maxlength="50" required [errorStateMatcher]="matcher()">
        @if (nameControl.invalid && attemptSave()) {
          <mat-error>Customer Name is required</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Contact Name</mat-label>
        <input matInput [(ngModel)]="contactName" name="contactName" placeholder="Enter Contact Name" maxlength="50">
      </mat-form-field>
    </div>

    <!-- Second Row -->
    <div class="form-grid-row cols-2">
      <mat-form-field appearance="outline">
        <mat-label>Contact Number</mat-label>
        <input matInput [(ngModel)]="contactPhone" #contactPhoneControl="ngModel" (input)="formatPhoneNumber($event, 1)"
          name="contactPhone" placeholder="(999) 000-0000" pattern="^\(\d{3}\) \d{3}-\d{4}$"
          [errorStateMatcher]="matcher()" (keydown)="phoneKeydown($event)" maxlength="14">
        @if (attemptSave() && contactPhoneControl.invalid && contactPhoneControl.errors?.['pattern']) {
          <mat-error>Enter a valid phone number in the format (XXX) XXX-XXXX</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Contact Email</mat-label>
        <input matInput type="email" email #contactEmailControl="ngModel" maxlength="50" [(ngModel)]="contactEmail"
          name="contactEmail" placeholder="Enter Email Address" maxlength="50">
        @if (attemptSave() && contactEmailControl.invalid && contactEmailControl.errors?.['email']) {
          <mat-error>Enter a valid email</mat-error>
        }
      </mat-form-field>
    </div>
     <!-- Fourth Row -->
    <div class="form-grid-row cols-2">
      <mat-form-field appearance="outline">
        <mat-label>Address Line 1</mat-label>
        <input matInput [(ngModel)]="addressLine1"  #addressCtrl="ngModel" name="addressLine1" placeholder="Enter Address Line 1"
          maxlength="50" required [errorStateMatcher]="matcher()">
          @if (addressCtrl.invalid && attemptSave()) {
            <mat-error>Address is required</mat-error>
          }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Address Line 2</mat-label>
        <input matInput [(ngModel)]="addressLine2" name="addressLine2" placeholder="Enter Address Line 2"
          maxlength="50">
      </mat-form-field>
    </div>

    <!-- Third Row -->
    <div class="form-grid-row cols-3">
      <mat-form-field appearance="outline">
        <mat-label>State</mat-label>
        <mat-select [(ngModel)]="state" #stateCtrl="ngModel" name="state" placeholder="Select State" required [errorStateMatcher]="matcher()"
          (selectionChange)="onStateChanged($event.value)">
          <div class="mat-select-search-container" (click)="$event.stopPropagation()">
            <input #stateSearchInput matInput placeholder="Search State..." (input)="filterStates($event)"
              class="mat-select-search-input" aria-label="Search State" (keydown)="$event.stopPropagation();" />
            <mat-icon class="mat-select-search-icon">search</mat-icon>
          </div>
          <mat-option [value]="null">Select State</mat-option>
          @for (state of states(); track state.id) {
            <mat-option [value]="state.id">{{ state.state }}</mat-option>
          }
        </mat-select>
        @if (stateCtrl.invalid && attemptSave()) {
          <mat-error>State is required</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>City</mat-label>
        <mat-select [(ngModel)]="city" #cityCtrl="ngModel" name="city" placeholder="Select City" required  [errorStateMatcher]="matcher()">
          <div class="mat-select-search-container" (click)="$event.stopPropagation()">
            <input #citySearchInput matInput placeholder="Search City..." (input)="filterCities($event)"
              class="mat-select-search-input" aria-label="Search City" (keydown)="$event.stopPropagation();" />
            <mat-icon class="mat-select-search-icon">search</mat-icon>
          </div>
          <mat-option [value]="null">Select City</mat-option>
          @for (city of cities(); track city.id) {
          <mat-option [value]="city.city">{{ city.city }}</mat-option>
          }
        </mat-select>
        @if (cityCtrl.invalid && attemptSave()) {
          <mat-error>City is required</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Zip Code</mat-label>
        <input matInput [(ngModel)]="zipCode" #zipCtrl="ngModel" name="zipCode" placeholder="Enter Zip Code" maxlength="10"
         required  [errorStateMatcher]="matcher()">
        @if (zipCtrl.invalid && attemptSave()) {
          <mat-error>Zip is required</mat-error>
        }
      </mat-form-field>
    </div>

   
    <!-- Fifth Row -->
    <div class="form-grid-row cols-2">

      <mat-form-field appearance="outline">
        <mat-label>Oracle Site Number</mat-label>
        <input matInput type="text" [(ngModel)]="siteNumber" name="siteNumber" placeholder="Enter Site Number"
          (input)="roundOff($event, 99999999, 0, 1)">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Oracle Account Number</mat-label>
        <input matInput type="text" [(ngModel)]="accountNumber" name="accountNumber" placeholder="Enter Account Number"
          (input)="roundOff($event, 99999999, 0, 2)">
      </mat-form-field>
    </div>

    <!-- Seventh Row -->
    <div class="form-grid-row cols-3">
      <mat-form-field appearance="outline">
        <mat-label>Logistics Contact Name</mat-label>
        <input matInput [(ngModel)]="logisticsContactName" name="logisticsContactName" placeholder="Enter Contact Name"
          maxlength="100">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Logistics Contact Number</mat-label>
        <input matInput [(ngModel)]="logisticsContactPhone" #lcontactPhoneControl="ngModel" maxlength="14"
          (input)="formatPhoneNumber($event, 2)" name="logisticsContactPhone" placeholder="(999) 000-0000"
          pattern="^\(\d{3}\) \d{3}-\d{4}$" [errorStateMatcher]="matcher()" (keydown)="phoneKeydown($event)">
          @if (attemptSave() && lcontactPhoneControl.invalid && lcontactPhoneControl.errors?.['pattern']) {
            <mat-error>Enter a valid phone number in the format (XXX) XXX-XXXX</mat-error>
          }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Logistics Contact Email</mat-label>
        <input matInput type="email" email #logisticsContactEmailControl="ngModel" maxlength="200"
          [(ngModel)]="logisticsContactEmail" name="logisticsContactEmail" placeholder="Enter Email Address">
        @if (attemptSave() && logisticsContactEmailControl.invalid && logisticsContactEmailControl.errors?.['email']) {
        <mat-error>Enter a valid email</mat-error>
        }
      </mat-form-field>
    </div>
    <!-- Sixth Row -->
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Market(s)</mat-label>
        <mat-select [(ngModel)]="MarketId" name="Markets" placeholder="Select Market(s)" #marketControl="ngModel"
          required [errorStateMatcher]="matcher()">
          <mat-option [value]="null">Select Market(s)</mat-option>
          @for (market of markets(); track market.id) {
          <mat-option [value]="market.id">{{ market.regionName }}</mat-option>
          }
        </mat-select>
        @if (marketControl.invalid && attemptSave()) {
        <mat-error>Market is required</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-slide-toggle [(ngModel)]="environment_Fee_Flag" name="environment_Fee_Flag" color="primary">
        <span class="font-medium text-gray-700 w-64 inline-block">Environment Fee Required</span>
      </mat-slide-toggle>
      
      <mat-slide-toggle data-testid="isVRSite" name="isVRSite"
        [(ngModel)]="isVRSite" color="primary" labelPosition="before">
        <span class="font-medium text-gray-700 w-44 inline-block">Is VR Site</span>
      </mat-slide-toggle>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-footer">
  <button data-testid="btnClose" mat-raised-button color="primary" mat-primary type="button" (click)="onClose()"> Cancel </button>
  @if(canSave){
    <button data-testid="btnSave" mat-raised-button color="primary" mat-primary type="submit" (click)="saveCustomerData()"> Save </button>
  }
</mat-dialog-actions>